import { localize } from 'helpers/translator'
import activityTypes from 'helpers/enums/activityTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

import oeqIcon from 'assets/views/interactive_video/activities/oeq_icon.svg'
import mcqIcon from 'assets/views/interactive_video/activities/mcq_icon.svg'
import oeqIconSmall from 'assets/views/interactive_video/activities/oeq_icon-small.svg'
import mcqIconSmall from 'assets/views/interactive_video/activities/mcq_icon-small.svg'

const activitiesMap = {
	[activityTypes.OPEN_ENDED_QUESTION]: {
		name: localize('global_slides_oeq'),
		icon: oeqIcon,
		iconSmall: oeqIconSmall,
		flagType: '',
	},
	[activityTypes.MULTIPLE_CHOICE_QUESTION]: {
		name: localize('global_slides_mcq'),
		icon: mcqIcon,
		iconSmall: mcqIconSmall,
		flagType: featureFlagsTypes.INTERACTIVE_VIDEO_MCQ,
	},
}

const getActivities = () => Object.keys(activitiesMap)
	.map(key => ({
		type: parseInt(key), // The returned object key is string but the activity type is really a int
		...activitiesMap[key],
	}))

export default getActivities

export {
	activitiesMap,
}
